export default __webpack_public_path__ + "static/media/frequency_meditation.e5ff1a2a.jpg";